import { render, staticRenderFns } from "./ShopGroups.vue?vue&type=template&id=b962a186&scoped=true&"
import script from "./ShopGroups.vue?vue&type=script&lang=js&"
export * from "./ShopGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b962a186",
  null
  
)

export default component.exports